import { getFmcAndFleetId } from "../actions/sagas/reportingSaga"

export function agGridColumnDefs(defaultCellRenderer, viewCellRenderer, t, paymentActivities) {
  const widths = {
    verySmall: 125,
    small: 150,
    medium: 175,
    large: 200,
    veryLarge: 225
  }
  var fields = [
    ...(getFmcAndFleetId().isFMC
      ? [
          {
            headerName: t("services:fleetName"),
            field: "fleet_name",
            flex: 1,
            cellRendererFramework: defaultCellRenderer
          }
        ]
      : []),
    {
      headerName: t("services:shopName"),
      field: "shop_name",
      cellRendererFramework: defaultCellRenderer,
      flex: 1
    },
    {
      headerName: t("services:shopOrder"),
      field: "shop_order_id",
      flex: 1,
      cellRendererFramework: defaultCellRenderer
    },
    {
      headerName: "Transaction Date",
      field: "created_at",
      flex: 1,
      cellRendererFramework: defaultCellRenderer
    },
    {
      headerName: t("services:invoiceNumber"),
      field: "id",
      flex: 1,
      cellRendererFramework: defaultCellRenderer
    },
    {
      headerName: t("services:amount"),
      field: "amount",
      flex: 1,
      cellRendererFramework: defaultCellRenderer
    },
    {
      headerName: t("services:typeLabel"),
      field: "type",
      flex: 1,
      cellRendererFramework: defaultCellRenderer
    },
    {
      headerName: "",
      field: "view_details",
      flex: 1,
      cellRendererFramework: viewCellRenderer
    }
  ]

  return fields
}

export function agGridRowData(paymentActivities, language) {
  return paymentActivities.map((paymentActivity) => {
    return {
      fleet_name: paymentActivity.fleet_name,
      shop_order_id: paymentActivity.shop_order_id,
      shop_order_date: paymentActivity.shop_order_date,
      id: paymentActivity.id,
      amount: "$" + Number(paymentActivity.amount).toFixed(2) || 0.0,
      type: paymentActivity.activity_type,
      view_details: paymentActivity.id,
      shop_name: paymentActivity.shop_name,
      created_at: paymentActivity.created_at
    }
  })
}

export const NA = "N/A"
export const PAYPAL = "paypal"
